export const GRN_DISCREPANCY_REPORT_ACTION = 'GRN_DISCREPANCY_REPORT_ACTION'
export const GRN_DISCREPANCY_REPORT_ACTION_SUCCESS = 'GRN_DISCREPANCY_REPORT_ACTION_SUCCESS'
export const GRN_DISCREPANCY_REPORT_ERROR_ACTION = 'GRN_DISCREPANCY_REPORT_ERROR_ACTION'

